import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c('back-link-component',{attrs:{"to":{ name: 'RefLineListAsList' },"label":_vm.$tt('customRefLine')}}),_c('h2',[_vm._v(_vm._s(_vm.$tt('customRefLineUploadTitle')))]),_c('geo-file-import',{attrs:{"importMode":_vm.importMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }